import api from "../../../../lib/api";
import { IAreaCodeCreate, IAreaCodeListSearch, IEditAreaCodePayload } from "../../../../types/master/areaCodeInterface";

export const createAreaCodeApi = async (data: IAreaCodeCreate) => {
  return await api.post(`/area-codes/`, data);
};

export const getAreaCodeListApi = async (data: IAreaCodeListSearch) => {
  return await api.get(`/area-codes/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getAreaCodeDataByIdApi = async (id: number) => {
  return await api.get(`/area-codes/${id}`)
}

export const editAreaCodeDataByIdApi = async (payload: IEditAreaCodePayload) => {
  return await api.put(`/area-codes/${payload.id}`, payload.data);
};

export const deleteAreaCodeApi = async (id: number) => {
  return await api.delete(`/area-codes/${id}`);
};


